import { useEffect, useState } from "react";
import "./Meus_servicos.css";

const API_URL = process.env.REACT_APP_API_URL;

const MeusServicos = () => {
  const [servicos, setServicos] = useState([]);
  const [novoServico, setNovoServico] = useState({
    nome: "", descricao: "", preco: "", cep: "", bairro: "", cidade: "", uf: "", categoria: ""
  });
  const [imagem, setImagem] = useState(null);
  const [categorias, setCategorias] = useState([]);
  const [servicoEditando, setServicoEditando] = useState(null);
  const [toast, setToast] = useState("");
  const [modalNovo, setModalNovo] = useState(false);

  const token = localStorage.getItem("token");

  useEffect(() => {
    listarServicos();
    fetch(`${API_URL}/categorias-servico`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then((res) => res.json())
      .then((data) => setCategorias(data))
      .catch(console.error);
  }, []);

  const listarServicos = () => {
    fetch(`${API_URL}/servicos/meus?sortBy=id&direction=desc`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((data) => setServicos(data.content || []))
      .catch((err) => console.error(err));
  };

  const buscarCEP = async (cep) => {
    try {
      const res = await fetch(`${API_URL}/cep/${cep}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      const dados = await res.json();
      setNovoServico((prev) => ({
        ...prev,
        cep: dados.cep,
        bairro: dados.bairro,
        cidade: dados.localidade,
        uf: dados.uf
      }));
    } catch (err) {
      console.error("Erro ao buscar CEP", err);
    }
  };

  const handleChangeNovo = (e) => {
    const { name, value } = e.target;
    setNovoServico((prev) => ({ ...prev, [name]: value }));
    if (name === "cep" && value.length >= 8) buscarCEP(value);
  };

  const criarServico = async () => {
    const formData = new FormData();
    Object.entries(novoServico).forEach(([key, val]) => formData.append(key, val));
    formData.append("ativo", "true");
    if (imagem) formData.append("imagem", imagem);

    try {
      const response = await fetch(`${API_URL}/servicos/com-imagem`, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` },
        body: formData,
      });

      if (response.ok) {
        mostrarToast("Serviço publicado com sucesso!");
        setNovoServico({ nome: "", descricao: "", preco: "", cep: "", bairro: "", cidade: "", uf: "", categoria: "" });
        setImagem(null);
        setModalNovo(false);
        listarServicos();
      } else {
        mostrarToast("Erro ao publicar serviço.");
      }
    } catch (error) {
      console.error(error);
      mostrarToast("Erro de conexão.");
    }
  };

  const abrirEditar = (servico) => setServicoEditando({ ...servico });

  const handleChangeEditar = (e) => {
    const { name, value } = e.target;
    setServicoEditando({ ...servicoEditando, [name]: name === "ativo" ? value === "true" : value });
  };

  const salvarEdicao = async () => {
    try {
      const response = await fetch(`${API_URL}/servicos/${servicoEditando.id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          nome: servicoEditando.nome,
          descricao: servicoEditando.descricao,
          preco: parseFloat(servicoEditando.preco),
          ativo: servicoEditando.ativo,
        }),
      });

      if (response.ok) {
        mostrarToast("Serviço atualizado com sucesso!");
        setServicoEditando(null);
        listarServicos();
      } else {
        mostrarToast("Erro ao atualizar serviço.");
      }
    } catch (error) {
      console.error(error);
      mostrarToast("Erro de conexão.");
    }
  };

  const excluirServico = async (id) => {
    if (!window.confirm("Deseja realmente excluir este serviço?")) return;
    try {
      await fetch(`${API_URL}/servicos/${id}`, {
        method: "DELETE",
        headers: { "Authorization": `Bearer ${token}` },
        credentials: "include",
      });
      mostrarToast("Serviço excluído.");
      listarServicos();
    } catch (error) {
      console.error(error);
    }
  };

  const mostrarToast = (mensagem) => {
    setToast(mensagem);
    setTimeout(() => setToast(""), 3000);
  };

  const fecharModal = () => setServicoEditando(null);

  return (
    <div className="servicos-container-meus">
      <div className="servicos-box-meus">
        <button className="btn-novo-meus" onClick={() => setModalNovo(true)}>+ Novo Serviço</button>

        {modalNovo && (
          <div className="modal-overlay-meus" onClick={() => setModalNovo(false)}>
            <div className="modal-content-meus" onClick={(e) => e.stopPropagation()}>
              <h2>Novo Serviço</h2>
              <input name="nome" placeholder="Nome" value={novoServico.nome} onChange={handleChangeNovo} />
              <input name="descricao" placeholder="Descrição" value={novoServico.descricao} onChange={handleChangeNovo} />
              <input name="preco" placeholder="Preço" type="number" step="0.01" value={novoServico.preco} onChange={handleChangeNovo} />
              <input name="cep" placeholder="CEP" value={novoServico.cep} onChange={handleChangeNovo} />
              <input name="bairro" placeholder="Bairro" value={novoServico.bairro} disabled />
              <input name="cidade" placeholder="Cidade" value={novoServico.cidade} disabled />
              <input name="uf" placeholder="UF" value={novoServico.uf} disabled />
              <select name="categoria" value={novoServico.categoria} onChange={handleChangeNovo}>
                <option value="">Selecione uma categoria</option>
                {categorias.map((cat) => (
                  <option key={cat.id} value={cat.label}>{cat.label}</option>
                ))}
              </select>
              <input type="file" accept="image/*" onChange={(e) => setImagem(e.target.files[0])} />
              <button className="btn-salvar-meus" onClick={criarServico}>Publicar</button>
              <button className="fechar-btn-meus" onClick={() => setModalNovo(false)}>Cancelar</button>
            </div>
          </div>
        )}

        {toast && <div className="toast">{toast}</div>}

        <h3 style={{ marginTop: "30px" }}>Serviços:</h3>

        {servicos.length === 0 ? (
          <p>Nenhum serviço encontrado.</p>
        ) : (
          <div className="servicos-lista-meus">
            {servicos.map((servico) => (
              <div key={servico.id} className="servico-card-meus card-flex-meus">
                <div className="card-info-meus">
                  <p className={servico.ativo ? "ativo" : "inativo"}>{servico.ativo ? "✅ Ativo" : "❌ Inativo"}</p>
                  <p><span>📍 {servico.cidade}, {servico.uf} • 📚 {servico.categoria}</span></p>
                  <p><span>🕒 {new Date(servico.dataHora).toLocaleString("pt-BR")}</span></p>
                  <br />
                  <h3>{servico.nome}</h3>
                  <p>{servico.descricao}</p>
                  <p><strong>💲 R$ {servico.preco.toFixed(2)}</strong></p>
                  <div className="botoes-abaixo-meus">
                    <button className="btn-editar-meus" onClick={() => abrirEditar(servico)}>Editar</button>
                    <button className="btn-excluir-meus" onClick={() => excluirServico(servico.id)}>Excluir</button>
                  </div>
                </div>
                {servico.imagem?.secureUrl && (
                  <div className="card-image-meus">
                    <img src={servico.imagem.secureUrl} alt={servico.nome} />
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>

      {servicoEditando && (
        <div className="modal-overlay-meus" onClick={fecharModal}>
          <div className="modal-content-meus" onClick={(e) => e.stopPropagation()}>
            <h2>Editar:</h2>
            <input name="nome" value={servicoEditando.nome} onChange={handleChangeEditar} placeholder="Nome" />
            <input name="descricao" value={servicoEditando.descricao} onChange={handleChangeEditar} placeholder="Descrição" />
            <input name="preco" type="number" value={servicoEditando.preco} onChange={handleChangeEditar} placeholder="Preço" />
            <select name="ativo" value={servicoEditando.ativo} onChange={handleChangeEditar}>
              <option value={true}>Ativo</option>
              <option value={false}>Inativo</option>
            </select>
            <button className="btn-salvar-meus" onClick={salvarEdicao}>Salvar</button>
            <button className="fechar-btn-meus" onClick={fecharModal}>Fechar</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MeusServicos;
